export default __webpack_public_path__ + "static/media/crew-chief-background.0aa346a1.webp";